import { mapObjectKeysToValues } from '../../utils/core/object';

export const RISK_STATISTIC_SETTINGS = {
    RESIDUAL_OUTSIDE_OF_RISK_APPETITE_PERCENTAGE_STEPS: [0, 30],
    WITHOUT_CONTROL_COUNT_STEPS: [0, 10],
    OVERDUE_ACTIONS_PERCENTAGE_STEPS: [0, 29],
} as const;

export const RISK_DECISIONS = {
    TREAT: 'Treat',
    TOLERATE: 'Tolerate',
    TERMINATE: 'Terminate',
    TRANSFER: 'Transfer',
} as const;

export const RISK_ACTION_PLAN_STATUSES = {
    TODO: 'To do',
    IN_PROGRESS: 'In progress',
    DONE: 'Done',
    NOT_REQUIRED: 'Not required',
} as const;

export const RISK_ACTION_PLAN_STATUSES_KEYS = mapObjectKeysToValues(RISK_ACTION_PLAN_STATUSES);

export const ACTION_PLAN_STATUS_FILTERS = {
    OPEN: 'Open actions',
    ALL: 'All actions',
} as const;

export type RiskDecision = keyof typeof RISK_DECISIONS;
export type RiskActionPlanStatus = keyof typeof RISK_ACTION_PLAN_STATUSES;
export type ActionPlanStatusFilter = keyof typeof ACTION_PLAN_STATUS_FILTERS;

export const actionPlanStatusFilterMap: { [K in ActionPlanStatusFilter]: RiskActionPlanStatus[] | undefined } = {
    OPEN: ['TODO', 'IN_PROGRESS'],
    ALL: undefined,
};
